import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function UnlockKeyholeRegular(rowId) {
  const [token, setToken] = useState("");
  const queryClient = useQueryClient();

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    if (JSON.parse(localStorage.getItem("auth")) === null || token === null) {
      navigate("/Login");
    }
  }, []);

  //修改帳號狀態
  const UpdateAccountStatus = async () => {
    const data = {
      Data: rowId,
    };
    const res = await apiClient.postAes("api/account/Status/Security", data);
    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return null;
    }

    return res?.data;
  };

  const { data, mutate, isSuccess, isLoading } = useMutation(
    UpdateAccountStatus,
    {
      onSuccess: () => {
        queryClient.invalidateQueries("sendSearchData");
      },
    }
  );

  useEffect(() => {
    const code = +data?.Code;

    if (isSuccess && code === 0) {
      alert("修改狀態成功");
    }
    if (code === 1 || code === 2) {
      alert(data?.Message);
    }
  }, [data]);

  return (
    <Container
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
        mutate({ UpdateAccountStatus });
      }}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke="#057AFF" />
      <path
        d="M12 8.36364C11.0134 8.36364 10.2143 9.12642 10.2143 10.0682V11.0909H15.5714C16.3594 11.0909 17 11.7024 17 12.4545V16.5455C17 17.2976 16.3594 17.9091 15.5714 17.9091H8.42857C7.64063 17.9091 7 17.2976 7 16.5455V12.4545C7 11.7024 7.64063 11.0909 8.42857 11.0909H8.78571V10.0682C8.78571 8.37429 10.2254 7 12 7C13.2835 7 14.3884 7.71804 14.904 8.75355C15.0737 9.09446 14.9219 9.50142 14.5647 9.66122C14.2076 9.82102 13.7812 9.67827 13.6138 9.33736C13.3259 8.75994 12.7121 8.36364 12 8.36364ZM12.7143 15.1818C13.1094 15.1818 13.4286 14.8771 13.4286 14.5C13.4286 14.1229 13.1094 13.8182 12.7143 13.8182H11.2857C10.8906 13.8182 10.5714 14.1229 10.5714 14.5C10.5714 14.8771 10.8906 15.1818 11.2857 15.1818H12.7143Z"
        fill="#057AFF"
      />
    </Container>
  );
}

export default UnlockKeyholeRegular;
